import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Typography } from '@mui/material';

import { colors } from 'themes';

const OptionName = styled(Typography)`
  font-weight: 500;
`;

const OptionMeta = styled(Typography)`
  display: block;
  color: ${colors.osloGray};
  font-size: 12.5px;
`;

/**
 * The standard two-line layout for an MUI Autocomplete search result: name in
 * medium weight with an optional gray metadata line below. Return it from the
 * Autocomplete's `renderOption`, keyed by the option's identity.
 */
const SearchResultOption = ({ meta, name, optionProps }) => (
  <li {...optionProps}>
    <div>
      <OptionName variant="body2">{name}</OptionName>
      {!!meta && <OptionMeta variant="caption">{meta}</OptionMeta>}
    </div>
  </li>
);

SearchResultOption.defaultProps = {
  meta: undefined,
};

SearchResultOption.propTypes = {
  /** Secondary line (e.g. office, formatted address); the line is omitted when falsy. */
  meta: PropTypes.node,
  /** Primary line, rendered in 500-weight body2. */
  name: PropTypes.node.isRequired,
  /** The props object MUI Autocomplete passes to `renderOption`; spread onto the `<li>`. */
  // eslint-disable-next-line react/forbid-prop-types
  optionProps: PropTypes.object.isRequired,
};

export default SearchResultOption;
